/**
 * PitchBook Admin API
 * PitchBook Admin OpenAPI specification
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {createAction} from '@reduxjs/toolkit';
import {ApiMethods, ConcurrentStrategies} from '@pb/middleware-api';
import {PayloadData} from '../types';
import type {EntitlementConflictRequest} from '../models/EntitlementConflictRequest';
import type {EntitlementConflictResponse} from '../models/EntitlementConflictResponse';
import type {Error} from '../models/Error';
import type {RelationPage} from '../models/RelationPage';
import type {SortDirection} from '../models/SortDirection';

export interface GetProductAccountEntitlementRelations$Request {
    accountId: number;
    pageNumber: number;
    pageSize: number;
    sortDirection: SortDirection;
    requestBody?: Array<string>;
}

export interface GetProductAccountEntitlementRelations$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const getProductAccountEntitlementRelationsRequest = createAction<PayloadData<void, GetProductAccountEntitlementRelations$Request>>('PRODUCT_ACCOUNT_ENTITLEMENTS__GET_PRODUCT_ACCOUNT_ENTITLEMENT_RELATIONS__REQUEST');
export const getProductAccountEntitlementRelationsSuccess = createAction<PayloadData<RelationPage, GetProductAccountEntitlementRelations$Request>>('PRODUCT_ACCOUNT_ENTITLEMENTS__GET_PRODUCT_ACCOUNT_ENTITLEMENT_RELATIONS__SUCCESS');
export const getProductAccountEntitlementRelationsFailure = createAction<PayloadData<Error, GetProductAccountEntitlementRelations$Request, true>>('PRODUCT_ACCOUNT_ENTITLEMENTS__GET_PRODUCT_ACCOUNT_ENTITLEMENT_RELATIONS__FAILURE');

export const getProductAccountEntitlementRelationsActions = [
    getProductAccountEntitlementRelationsRequest,
    getProductAccountEntitlementRelationsSuccess,
    getProductAccountEntitlementRelationsFailure
] as const;

/**
 * @param {number} meta.accountId
 * @param {number} meta.pageNumber
 * @param {number} meta.pageSize
 * @param {SortDirection} meta.sortDirection
 * @param {Array<string>} [meta.requestBody]
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const getProductAccountEntitlementRelations = (meta: GetProductAccountEntitlementRelations$Request, config?: GetProductAccountEntitlementRelations$Config) => {
    const TRANSPORT_GET_PARAMS = {
        pageNumber: meta.pageNumber,
        pageSize: meta.pageSize,
        sortDirection: meta.sortDirection,
    };
    return {
        CALL_API: {
            types: getProductAccountEntitlementRelationsActions,
            method: ApiMethods.PUT,
            endpoint: `/web-api/product/account/${meta.accountId}/entitlements`,
            TRANSPORT_GET_PARAMS,
            TRANSPORT_REQUEST_BODY: meta.requestBody,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

export interface ProductAccountEntitlementConflictChecker$Request {
    accountId: number;
    entitlementConflictRequest?: EntitlementConflictRequest;
}

export interface ProductAccountEntitlementConflictChecker$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const productAccountEntitlementConflictCheckerRequest = createAction<PayloadData<void, ProductAccountEntitlementConflictChecker$Request>>('PRODUCT_ACCOUNT_ENTITLEMENTS__PRODUCT_ACCOUNT_ENTITLEMENT_CONFLICT_CHECKER__REQUEST');
export const productAccountEntitlementConflictCheckerSuccess = createAction<PayloadData<Array<EntitlementConflictResponse>, ProductAccountEntitlementConflictChecker$Request>>('PRODUCT_ACCOUNT_ENTITLEMENTS__PRODUCT_ACCOUNT_ENTITLEMENT_CONFLICT_CHECKER__SUCCESS');
export const productAccountEntitlementConflictCheckerFailure = createAction<PayloadData<Error, ProductAccountEntitlementConflictChecker$Request, true>>('PRODUCT_ACCOUNT_ENTITLEMENTS__PRODUCT_ACCOUNT_ENTITLEMENT_CONFLICT_CHECKER__FAILURE');

export const productAccountEntitlementConflictCheckerActions = [
    productAccountEntitlementConflictCheckerRequest,
    productAccountEntitlementConflictCheckerSuccess,
    productAccountEntitlementConflictCheckerFailure
] as const;

/**
 * @param {number} meta.accountId
 * @param {EntitlementConflictRequest} [meta.entitlementConflictRequest]
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const productAccountEntitlementConflictChecker = (meta: ProductAccountEntitlementConflictChecker$Request, config?: ProductAccountEntitlementConflictChecker$Config) => {
    return {
        CALL_API: {
            types: productAccountEntitlementConflictCheckerActions,
            method: ApiMethods.PUT,
            endpoint: `/web-api/product/account/${meta.accountId}/entitlements-conflicts`,
            TRANSPORT_REQUEST_BODY: meta.entitlementConflictRequest,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

